module.exports = __webpack_public_path__ + "img/SocialX.92b187dd.svg";